import icon1 from '../../../Assets/Icons/job1.svg';
import icon2 from '../../../Assets/Icons/job2.svg';
import icon3 from '../../../Assets/Icons/job3.svg';
import icon4 from '../../../Assets/Icons/job4.svg';
import icon5 from '../../../Assets/Icons/job5.svg';
import icon6 from '../../../Assets/Icons/job6.svg';
import icon7 from '../../../Assets/Icons/job7.svg';

export const jobs = [
    {
        icon:icon1,
        title:"Location",
        desc:"Mirpur 10, Dhaka, Bangladesh"
    },
    {
        icon:icon2,
        title:"Job Type",
        desc:"Full Time"
    },
    {
        icon:icon3,
        title:"Date Posted",
        desc:"Posted 2 months ago"
    },
    {
        icon:icon4,
        title:"Experience",
        desc:"Experience: 2 Years"
    },
    {
        icon:icon5,
        title:"Working Hours",
        desc:"8AM - 5PM"
    },
    {
        icon:icon6,
        title:"Working Days",
        desc:"Weekly: 5 days. Weekend: Saturday, Sunday."
    },
    {
        icon:icon7,
        title:"Vacancy",
        desc:"No. of Vacancies: 1"
    }
]


export const responsibilities = [
    'Developing custom themes (WordPress.org & ThemeForest Standards)',
    'Creating reactive website designs',
    'Working under strict deadlines',
    'Develop page speed optimized themes'
]

export const requirements = [
    'Having approved theme/s on ThemeForest will be given high preference.',
    'Strong knowledge of WordPress Theme Standards',
    'Ability to convert HTML templates into fully functional WordPress themes.',
    'Good knowledge in OOP PHP and front-end stuffs like HTML, CSS, JS, jQuery, etc.',
    'Moderate knowledge in WordPress Core APIs like options, metadata, REST, hooks, settings, etc.',
    'Ability to debug and fix bugs arising from other developer’s code.',
    'Sense of humor 😉',
    'Hard worker and passionate – we are growing super FAST 🚀'
]

export const hours = [
    '8 AM – 5 PM'
]
export const days = [
    'Weekly: 5 days.',
    'Weekend: Saturday, Sunday.'
]
export const salary = [
    'TK. 35,000 – 70,000 USD (Depends on Skill and Experience)',
    'Salary Review: Yearly'
]

export const benefits = [
    'Work in a flat organization where your voice is always heard',
    'Provident fund.',
    'Gratuity.',
    'Medical Fund.',
    'Having Corporate deals with multiple Hospitals.',
    'Performance bonus.',
    'Increment: Yearly.',
    'Lunch Facilities: Full Subsidize.',
    'Unlimited Tea, Coffee & Snacks.',
    'Annual tour.',
    'Team Outing.',
    'Marriage Bonus and Marriage Leave.',
    'Paternity and Maternity Leave.',
    'Yearly Family Tour.',
    'Knowledge Sharing Session.',
    'Table Tennis(Ping Pong) :table_tennis_paddle_and_ball:',
    'Last but not the least, WorldClass Work Environment. 😎'
]
export const process = [
    'An Assignment to Complete.',
    'Interview with the Team Lead & HR Team.',
    'Final Interview with the Board of Directors.',
    'Reference Check.',
    'A Formal Job Offer.'
]

export const related = [
    {
        title:"Technical Support Engineer",
        desc:"Job Type: Full Time Deadline: July 31, 2021"
    },
    {
        title:"Director of Marketing",
        desc:"Job Type: Full Time  Deadline: July 31, 2021" 
    },
    {
        title:"Senior Web Application Developer",
        desc:"Job Type: Full Time  Deadline: July 31, 2021"
    },
    {
        title:"Lead Developer (React, Vanilla)",
        desc:"Job Type: Full Time  Deadline: July 31, 2021"
    },
    {
        title:"Product Designer",
        desc:"Job Type: Full Time Deadline: July 31, 2021"
    }
]